__turbopack_context__.v({
  "period": "DonationsTotal-module-scss-module__aWSH1a__period",
  "totals": "DonationsTotal-module-scss-module__aWSH1a__totals",
});
